<template>
  <div>
    <b-modal
      id="modal-stranger"
      centered
      size="lg"
      :hide-footer="true"
      ref="modal-stranger"
      :title="stranger.in_time"
    >
      <b-img :src="stranger.image" style="width:100%"/>
    </b-modal>
    
    <b-row>
      
      <b-col cols="12">
   
    <!-- table -->
        <b-card>
            <!-- <span @click=get_data>REFRESH</span> -->
    <b-table
      ref="selectableTable"
      selectable
      :select-mode="selectMode"
      :items="items"
      @row-selected="stranger_image"
      :fields="fields"
      responsive
      striped
      class="mb-0"
    >
      <template #cell(actions)="data">
        <b-dropdown
          variant="link"
          no-caret
          :right="$store.state.appConfig.isRTL"
        >

          <template #button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </template>
          <b-dropdown-item :to="{ name: 'apps-Member-view', params: { id: data.item.id } }">
            <feather-icon icon="FileTextIcon" />
            <span class="align-middle ml-50">Details</span>
          </b-dropdown-item>

          <b-dropdown-item :to="{ name: 'apps-Member-edit', params: { id: data.item.id } }">
            <feather-icon icon="EditIcon" />
            <span class="align-middle ml-50">Edit</span>
          </b-dropdown-item>

          <b-dropdown-item>
            <feather-icon icon="TrashIcon" />
            <span class="align-middle ml-50">Delete</span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
      <template #cell(target_name)="data">
         <b-link v-if="data.item.target_type == 'MEMBER'" :to="'/apps/member/edit/'+data.item.taget_token+'/'"><b>{{data.item.target_name}}</b></b-link>
         <b-link v-if="data.item.target_type == 'STAFF'" :to="'/apps/staff/edit/'+data.item.taget_token+'/'"><b>{{data.item.target_name}}</b></b-link>
        </template>
      <template #cell(total_amount)="data">
        <b-badge variant="primary">
          $ {{ data.value }}
        </b-badge>
      </template>
      <template #cell(plan_type)="data">
        <b-badge variant="primary" class="d-block" v-if="data.value=='TERMS'">
          {{ data.value }}
        </b-badge>
        <b-badge variant="warning" class="d-block" v-if="data.value=='DUES'">
          {{ data.value }}
        </b-badge>
      </template>
      <template #cell(plan_status)="data">
        <b-badge variant="light-success" class="d-block" v-if="data.value=='ACTIVE'">
          {{ data.value }}
        </b-badge>
        <b-badge variant="light-danger" class="d-block" v-if="data.value=='DISABLED'">
          {{ data.value }}
        </b-badge>
         <b-badge variant="light-dark" class="d-block" v-if="data.value!='DISABLED' && data.value!='ACTIVE'">
          NOT FOUND
        </b-badge>
      </template>
      <template #cell(normal_count)="data">
       <span class="font-weight-bolder">{{ data.value }}</span>
      </template>
    </b-table>

  </b-card>
    </b-col>
    </b-row>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment'
import {
  BMedia,
  BMediaAside,
  BCardHeader,
  BCardTitle,
  BMediaBody,BCard, BImg , BTable,BTime, BAvatar, BCardBody, BLink,BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BInputGroupPrepend,BModal, VBModal} from 'bootstrap-vue'
export default {
  components: {
    moment,
    BImg,
    BCard,
    BCardHeader,
    BCardTitle,
    flatPickr,
    BTable,
    BModal, VBModal,
    BAvatar,
    BLink,
    BBadge,
    BRow,
    BCol,
    BMedia,
  BMediaAside,
  BMediaBody,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BButton,
    BPagination,
    BCardCode,
    BTable,
    BButton,
    BTime,
    BFormGroup,
    BAvatar,
    BCardBody,
    BBadge,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      selected_status : 'ALL',
      rangeDate: null,
      test_string : null,
      user_id : 'all',
      stats : {
        total_amount : 0,
        total_person : 0
      },
      staffOptions : [],
      target_type:'ALL',
      headerTitle: [],
      headerVal: [],
      genderOptions: [
        { label: 'Male', value: 'M' },
        { label: 'Female', value: 'F' },
      ],
      planOptions: [
        { label: 'Basic', value: 'basic' },
        { label: 'Company', value: 'company' },
        { label: 'Enterprise', value: 'enterprise' },
        { label: 'Team', value: 'team' },
      ],
      targetOptions: [
        { label: 'ALL', value: 'ALL' },
        { label: 'STAFF', value: 'STAFF' },
        { label: 'MEMBER', value: 'MEMBER' }
      ],
      statusOptions: [
        { label: 'GRANT', value: 'GRANT' },
        { label: 'DENY', value: 'DENY' },
        { label: 'WARNING', value: 'WARNING' },
      ],
      centerOptions: [],
      salary: 0,
      isAddNewMemberSidebarActive: false,
      stranger : {
        in_time : null
      },
      searchString: null,
      time:{
        from:'00:00',
        to:'23:59'
      },
      stranger_image_src: null,
      perPage: 10,
      startRow: 1,
      endRow: 10,
      pageOptions: [10, 15, 20],
      totalRows: 1,
      currentPage: 1,
      fields: [],
      /* eslint-disable global-require */
      items: [],
      /* eslint-disable global-require */
      status: [{
        1: 'Grant', 2: 'Deny',3:'Warning'
      },
      {
        1: 'light-success', 2: 'light-danger',3: 'light-warning'
      }],
      selectMode: 'single',
      selected: [],
    }
  },
  watch: {
    user_id : {
      handler(newValue, oldValue) {
        this.get_data()
      },
    },
    rangeDate : {
      handler(newValue, oldValue) {
        this.get_data()
      },
    },
    selected_status : {
      handler(newValue, oldValue) {
        this.get_data()
      },
    },
    currentPage: {
      handler(newValue, oldValue) {
        this.get_data()
      },
    },
    searchString: {
      handler(newValue, oldValue) {
        // console.log("search")
        this.searchString = newValue.toUpperCase()
        this.handleSearch()
      },
    },
    perPage: {
      handler(newValue, oldValue) {
        if (newValue < 9) {
          this.perPage = 10
        }
        // console.log("search")
        this.handleSearch()
      },
    },
  },
  created() {
    this.get_data()
  },
  methods: {
    exportToExcel() {
         import('@/@core/Export2Excel').then(excel => {
           const list = this.items
   
           const data = this.formatJson(this.headerVal, list)
           excel.export_json_to_excel({
             header: this.headerTitle,
             data,
             filename: 'monthly-schedule',
             autoWidth: true,
             bookType: 'xlsx'
           })
           //this.clearFields()
         })
       },
formatJson(filterVal, jsonData) {
  return jsonData.map(row =>
    filterVal.map(key => {
      const value = row[key]
      const type = this.fieldTypes[key]

      if (value === null || value === '') return ''

      switch (type) {
        case 'int':
          return parseInt(value)
        case 'float':
          return parseFloat(value)
        case 'boolean':
          return value ? 'Yes' : 'No'
        case 'date':
          return moment(value).format('YYYY-MM-DD')
        case 'datetime':
          return moment(value).format('YYYY-MM-DD HH:mm')
        default:
          return value
      }
    })
  ) 
},

 get_data() {

  this.$http.get(process.env.VUE_APP_API_BASE + `/report/membership-v2/`)
    .then(res => {
          this.fields = res.data.fields
      this.items = res.data.records
      this.stats = res.data.stats
      this.headerTitle = res.data.excel_fields.map(f => f.label)
      this.headerVal = res.data.excel_fields.map(f => f.key)
      this.fieldTypes = res.data.excel_fields.reduce((map, f) => {
        map[f.key] = f.type
        return map
      }, {})
    })
},
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style lang="scss">
.b-table-selectable{
  .feather{
    font-size: 1.3rem;
  }
}

</style>
